import { Box, Dialog, IconButton } from '@mui/material'
import { useTranslation } from 'react-i18next'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import ReactJson from '@microlink/react-json-view'
import { Dispatch, SetStateAction } from 'react'
import theme from 'lib/theme'

type TextToCopy = {
  boosts: {
    fields: {
      name: number
      name_keyword: number
      keywords: number
      brand: number
      description: number
      functional_name: number
      categories_name: number
      categories_parent_name: number
      gtin: number
    }
    min_score: number
  }
}

type ExportConfigDialogProps = {
  dialogOpen: boolean
  setDialogOpen: Dispatch<SetStateAction<boolean>>
  textToCopy: TextToCopy
}

export const ExportConfigDialog = ({
  dialogOpen,
  setDialogOpen,
  textToCopy,
}: ExportConfigDialogProps) => {
  const { t } = useTranslation()

  const handleCloseDialog = () => {
    setDialogOpen(false)
  }

  // reactjsonview copy does not work with mui otherwise
  const handleCopy = (copy: {
    src: object
    namespace: Array<string | null>
    name: string | null
  }) => {
    navigator.clipboard.writeText(JSON.stringify(copy.src, null, 2))
  }

  return (
    <Dialog open={dialogOpen} onClose={handleCloseDialog}>
      <Box p={2}>
        <Box display='flex' justifyContent='flex-end'>
          <IconButton
            aria-label={t('copyToClipboard')}
            onClick={() =>
              navigator.clipboard.writeText(JSON.stringify(textToCopy))
            }>
            <ContentCopyIcon />
          </IconButton>
        </Box>
        <ReactJson
          enableClipboard={handleCopy}
          src={textToCopy}
          theme='grayscale:inverted'
          style={{
            backgroundColor: theme.palette.neutral.grey12,
            minWidth: '380px',
          }}
        />
      </Box>
    </Dialog>
  )
}
